import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StyledTitle, StyledSubtitle } from './styled';

const Header = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <StyledTitle>{t('distribution:payout:title')}</StyledTitle>
      <StyledSubtitle>{t('distribution:payout:subtitle')}</StyledSubtitle>
    </Box>
  );
};

export default Header;
